import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducer from "./rootReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["responseManagerReducer"]
};

export default function configureStore(initialState) {
  const isClient = typeof window !== "undefined";

  if (isClient) {
    const devTools =
      process.env.NODE_ENV === "production"
        ? applyMiddleware(thunk)
        : composeWithDevTools(applyMiddleware(thunk));
    const store = createStore(
      persistReducer(persistConfig, reducer),
      initialState,
      devTools
    );
    let persistor = persistStore(store);
    store.__PERSISTOR = persistor;
    return store;
  } else {
    const devTools =
      process.env.NODE_ENV === "production"
        ? applyMiddleware(thunk)
        : composeWithDevTools(applyMiddleware(thunk));
    const store = createStore(reducer, initialState, devTools);
    return store;
  }
}
